@if (solutionSpace$ | async; as solutionSpace) { @if (componentId$ | async; as componentId) {
<app-component-datalog
  [solutionSpace]="solutionSpace"
  [componentId]="componentId"
  [datalogs$]="datalogs$"
  (dateRangeUpdate)="updateDatalog($event)"
>
</app-component-datalog>
} }
